import { render, staticRenderFns } from "./entity-card-requests-detail-process-request-extra-budget-details.vue?vue&type=template&id=0af89e98&"
import script from "./entity-card-requests-detail-process-request-extra-budget-details.vue?vue&type=script&lang=js&"
export * from "./entity-card-requests-detail-process-request-extra-budget-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports